import classNames from 'classnames';
import React, { memo, useId } from 'react';
import { Icon, IconType } from '../icon/icon.component';
import { Text } from '../text/text.component';
import './checkbox.component.scss';

export declare namespace CheckboxType {
  type Props = {
    className?: string | null;
    onChange?: ({
      checked,
      event,
    }: {
      checked: boolean;
      event: React.MouseEvent<HTMLInputElement>;
    }) => void | null;
    checked?: boolean | null;
    variant?: 'select' | 'deselect';
    size?: Extract<'xs' | 's', IconType.Props['size']>;
    label?: string | null;
    disabled?: boolean | null;
    name?: string;
  };
}

export const Checkbox = memo(
  ({
    className,
    onChange,
    checked,
    variant = 'select',
    size = 's',
    label,
    disabled = false,
    name,
  }: CheckboxType.Props) => {
    const id = useId();
    return (
      <label htmlFor={id} className={classNames('checkbox', className)}>
        <div
          className={classNames('checkbox__input', {
            'checkbox__input--disabled': disabled,
          })}
        >
          <input
            id={id}
            name={name}
            className={classNames('checkbox__input__native', {
              'checkbox__input__native--disabled': disabled,
            })}
            type="checkbox"
            checked={!!checked}
            onClick={(event) => {
              event.stopPropagation();
              if (disabled) return;
              onChange?.({ checked: !checked, event });
            }}
          />
          {checked && variant === 'select' && (
            <Icon variant="checkbox-active" size={size} color="deep_indigo" />
          )}
          {checked && variant === 'deselect' && (
            <Icon variant="checkbox-deselect" size={size} color="deep_indigo" />
          )}
          {!checked && (
            <Icon
              variant="checkbox-unactive"
              size={size}
              color={'deep_indigo'}
            />
          )}
        </div>
        {label && (
          <Text whiteSpace="nowrap" variant="subhead" color="deep_indigo">
            {label}
          </Text>
        )}
      </label>
    );
  },
);

export const CheckboxGroup = memo(
  ({ children }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
    return (
      <div
        className="checkboxGroup"
        style={{
          gridTemplateColumns: `repeat(${React.Children.count(children)}, 1fr)`,
        }}
      >
        {React.Children.map(children, (child, index) => (
          <div className="checkboxGroup__item" key={`checkbox-group-${index}`}>
            {child}
          </div>
        ))}
      </div>
    );
  },
);
